import { get } from 'lodash'
import moment from 'moment'
import React from 'react'
import hooks from '../../../hooks'

const useReport = ({
    id: reportId,
    queryFields = {},
}) => {
    const [isLoading, setLoading] = React.useState(false)
    const [results, setResults] = React.useState()
    const [date, setDate] = React.useState()
    const { api, endpoints, url } = hooks.useApi()
    const { toastError } = hooks.useToasts()

    const generateReport = React.useCallback(async () => {
        setLoading(true)
        setResults()
        setDate(moment())
        try {
            const results = await api.get(url(endpoints.report, { reportId }, queryFields ), { timeout: 30000})
            setResults(results)
        } catch (err) {
            toastError(err)
        }
        setLoading(false)
        
    }, [reportId, queryFields])

    return {
        date,
        generateReport,
        isLoading,
        records: get(results, 'records', []),
        columns: get(results, 'columns', [])
    }
}

export default useReport
